/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PoiProperty
 */
export interface PoiProperty {
    /**
     * 
     * @type {number}
     * @memberof PoiProperty
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PoiProperty
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PoiProperty
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof PoiProperty
     */
    categoryName: string;
    /**
     * 
     * @type {string}
     * @memberof PoiProperty
     */
    categoryIcon?: string;
    /**
     * 
     * @type {string}
     * @memberof PoiProperty
     */
    geographyName?: string;
    /**
     * 
     * @type {number}
     * @memberof PoiProperty
     */
    geoLongitude?: number;
    /**
     * 
     * @type {number}
     * @memberof PoiProperty
     */
    geoLatitude?: number;
    /**
     * 
     * @type {string}
     * @memberof PoiProperty
     */
    distance?: string;
    /**
     * 
     * @type {string}
     * @memberof PoiProperty
     */
    durationCar?: string;
    /**
     * 
     * @type {string}
     * @memberof PoiProperty
     */
    durationPublicTransport?: string;
    /**
     * 
     * @type {string}
     * @memberof PoiProperty
     */
    durationFoot?: string;
}

export function PoiPropertyFromJSON(json: any): PoiProperty {
    return PoiPropertyFromJSONTyped(json, false);
}

export function PoiPropertyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PoiProperty {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'categoryName': json['categoryName'],
        'categoryIcon': !exists(json, 'categoryIcon') ? undefined : json['categoryIcon'],
        'geographyName': !exists(json, 'geographyName') ? undefined : json['geographyName'],
        'geoLongitude': !exists(json, 'geoLongitude') ? undefined : json['geoLongitude'],
        'geoLatitude': !exists(json, 'geoLatitude') ? undefined : json['geoLatitude'],
        'distance': !exists(json, 'distance') ? undefined : json['distance'],
        'durationCar': !exists(json, 'durationCar') ? undefined : json['durationCar'],
        'durationPublicTransport': !exists(json, 'durationPublicTransport') ? undefined : json['durationPublicTransport'],
        'durationFoot': !exists(json, 'durationFoot') ? undefined : json['durationFoot'],
    };
}

export function PoiPropertyToJSON(value?: PoiProperty | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'address': value.address,
        'categoryName': value.categoryName,
        'categoryIcon': value.categoryIcon,
        'geographyName': value.geographyName,
        'geoLongitude': value.geoLongitude,
        'geoLatitude': value.geoLatitude,
        'distance': value.distance,
        'durationCar': value.durationCar,
        'durationPublicTransport': value.durationPublicTransport,
        'durationFoot': value.durationFoot,
    };
}


